import { ApolloLink, fromPromise, Observable } from '@apollo/client';

import { isPublic, refreshAuth, setSignedOut } from 'src/hooks/useAuth.hook';

let isRefreshing = false;
let pendingRequests: Array<() => void> = [];

const resolvePendingRequests = () => {
  pendingRequests.map((callback) => callback());
  pendingRequests = [];
};

// Checks whether document.cookie starts with s=true (1 cookie) or has a match for whitespace s=true (multiple cookies)
const signInCookieRegEx = /((^s)|(\ss))=true/gm;

// checks if user is signed in before forwarding the request
// if not, refreshes the auth before forwarding
export const checkAuthMiddleware = new ApolloLink((operation, forward) => {
  if (document.cookie.match(signInCookieRegEx)?.length !== 1 && !isPublic) {
    let forward$: Observable<string | void | undefined>;
    // Modify the operation context with a new token
    if (!isRefreshing) {
      isRefreshing = true;
      forward$ = fromPromise(
        refreshAuth()
          .then(() => {
            resolvePendingRequests();
          })
          .catch(() => {
            pendingRequests = [];
            setSignedOut();
            return;
          })
          .finally((): void => {
            isRefreshing = false;
          }),
      ).filter((value) => Boolean(value));
    } else {
      // Will only emit once the Promise is resolved
      forward$ = fromPromise(
        new Promise<void>((resolve) => {
          pendingRequests.push(() => resolve());
        }),
      );
    }
    return forward$.flatMap(() => forward(operation));
  }
  return forward(operation);
});
